/**
 * A project's History as an open item (RFC 0313 3i).
 *
 * Like a web page, it is not a document, so its id CARRIES what it is about:
 * `history:<projectId>`. Everything that restores an open item after a refresh
 * takes an id and nothing else, so the id has to be self-describing.
 */

const PREFIX = 'history:'

export const isHistoryId = (id: string): boolean => id.startsWith(PREFIX)

export const historyId = (projectId: string): string => `${PREFIX}${projectId}`

export function historyProjectOf(id: string): string | null {
  return isHistoryId(id) ? id.slice(PREFIX.length) || null : null
}

/** The open item for a project's History. */
export function historySubject(projectId: string) {
  return {
    id: historyId(projectId),
    title: 'History',
    path: 'History',
    mime: 'application/x-mod-history',
  }
}
